import { useState } from 'react'
import type { ContactPayload, FormStatus } from '../types/contact'

const API_BASE = process.env.REACT_APP_API_BASE_URL ?? ''

interface UseContactReturn {
  status: FormStatus
  errorMessage: string | null
  submit: (payload: ContactPayload) => Promise<void>
  reset: () => void
}

export function useContact(): UseContactReturn {
  const [status, setStatus]             = useState<FormStatus>('idle')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const submit = async (payload: ContactPayload): Promise<void> => {
    setStatus('loading')
    setErrorMessage(null)

    try {
      /*
       * L'API attend un multipart/form-data car le champ File est un IFormFile.
       * On ne passe PAS de Content-Type header — le navigateur le génère
       * automatiquement avec le bon boundary quand on envoie un FormData.
       */
      const formData = new FormData()
      formData.append('email',   payload.email)
      formData.append('subject', payload.subject)
      formData.append('content', payload.content)

      /* On n'ajoute le fichier que s'il est présent */
      if (payload.file) {
        formData.append('file', payload.file)
      }

      const response = await fetch(`${API_BASE}/api/contact`, {
        method: 'POST',
        /* ⚠️ Ne pas définir Content-Type manuellement ici */
        body: formData,
      })

      if (!response.ok) {
        let message = 'Une erreur est survenue. Veuillez réessayer.'
        try {
          const data = await response.json()
          if (data?.message) message = data.message
        } catch {
          // réponse non-JSON : message générique
        }
        throw new Error(message)
      }

      setStatus('success')
    } catch (err) {
      setErrorMessage(
        err instanceof Error ? err.message : 'Une erreur inattendue est survenue.'
      )
      setStatus('error')
    }
  }

  const reset = () => {
    setStatus('idle')
    setErrorMessage(null)
  }

  return { status, errorMessage, submit, reset }
}